module.exports = __webpack_public_path__ + "img/sun-with-2cloud-littlerain.2efc64e4.png";